export function farloUiDrawer(element) {
  const elementID = element.getAttribute('data-drawer');
  const button = document.querySelector(`.farlo-ui-drawer__button[data-drawer="${elementID}"]`);

  if (!button) return;

  if (!element.querySelector('.farlo-ui-drawer__close')) {
    const closeButton = document.createElement('button');
    closeButton.className = 'farlo-ui-drawer__close';
    closeButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="200" y1="56" x2="56" y2="200" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="200" y1="200" x2="56" y2="56" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>';
    element.prepend(closeButton);

    closeButton.addEventListener('click', () => {
      element.classList.remove('farlo-ui-drawer--open');
      document.body.classList.remove('farlo-ui-drawer--open');
    });
  }

  button.addEventListener('click', () => {
    element.classList.toggle('farlo-ui-drawer--open');
    document.body.classList.toggle('farlo-ui-drawer--open');
  });
}
